import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ClientsOverview = () => {
  const navigate = useNavigate();
  const [selectedClients, setSelectedClients] = useState([]);

  const clients = [
    {
      id: 1,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 95,
      status: "open",
      posted_date: "March 1, 2025",
    },
    {
      id: 2,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 87,
      status: "open",
      posted_date: "Feb 25, 2025",
    },
    {
      id: 3,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 93,
      status: "open",
      posted_date: "Jan 30, 2025",
    },
    {
      id: 4,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 85,
      status: "open",
      posted_date: "Jan 24, 2025",
    },
    {
      id: 5,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 90,
      status: "open",
      posted_date: "Dec 22, 2024",
    },
    {
      id: 6,
      name: "Morph & Mind",
      sector: "IT Services & IT Consulting",
      addresses: ["New York, NY, USA", "San Francisco, CA, USA"],
      ai_score: 88,
      status: "closed",
      posted_date: "Dec 18, 2024",
    },
  ];

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedClients(clients.map((c) => c.id));
    } else {
      setSelectedClients([]);
    }
  };

  const handleSelectClient = (id) => {
    setSelectedClients((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  return (
    <div className="lg:p-8 p-4">
      <div className="mb-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Clients</h1>
            <p className="mt-1 text-sm text-gray-600">
              Here is a complete overview of your clients.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <button className="px-4 py-2 flex items-center gap-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer">
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
              </svg>
              Import
            </button>
                 <button
              onClick={() => navigate("/performance")}
              className="px-4 py-2 flex items-center gap-2 text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] cursor-pointer"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              dashboard
            </button>
            <button
              onClick={() => navigate("/create_client")}
              className="px-4 py-2 flex items-center gap-2 text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] cursor-pointer"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              Add New Client
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200">
        <div className="pt-3 px-5">
          <h3 className="text-sm font-semibold text-gray-900">Total Clients</h3>
        </div>
        <div className="flex gap-3 items-end py-4 px-5 border-b border-gray-200">
          <h3 className="text-2xl text-gray-900 font-semibold">120</h3>
          <div className="flex items-center gap-1 text-sm text-emerald-600">
            <span>↑ 8.6%</span>
            <span className="text-gray-600 ml-1">vs last 30 days</span>
          </div>
        </div>

        <div className="flex justify-end items-center gap-3 py-4 px-5 border-b border-gray-200">
          <button className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
              />
            </svg>
            Filter
          </button>

          <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg p-1">
            <button className="p-2 rounded hover:bg-gray-50 cursor-pointer">
              <svg
                className="w-5 h-5 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
            <button className="p-2 rounded bg-gray-100 cursor-pointer">
              <svg
                className="w-5 h-5 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
            </button>
            <button className="p-2 rounded hover:bg-gray-50 cursor-pointer">
              <svg
                className="w-5 h-5 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-5 py-3 text-left">
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={selectedClients.length === clients.length}
                      onChange={handleSelectAll}
                      className="rounded border-gray-300 cursor-pointer"
                    />
                    <span className="text-xs font-semibold text-gray-500 uppercase">
                      Client
                    </span>
                  </div>
                </th>
                <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                  Sector
                </th>
                <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                  Addresses
                </th>
                <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                  Avg. AI Score
                </th>
                <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                  Status
                </th>
                <th className="px-5 py-3 text-left text-xs font-semibold text-gray-500 uppercase">
                  Posted Date
                </th>
                <th className="px-5 py-3"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {clients.map((client) => (
                <tr key={client.id} className="hover:bg-gray-50"onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/clients/${client.id}`);
                            }}>
                  <td className="px-5 py-4" >
                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        checked={selectedClients.includes(client.id)}
                        onChange={() => handleSelectClient(client.id)}
                        className="rounded border-gray-300 cursor-pointer"
                      />
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-purple-600 flex items-center justify-center flex-shrink-0">
                          <svg
                            className="w-5 h-5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                          </svg>
                        </div>
                        <span className="font-medium text-sm text-gray-900">
                          {client.name}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <span className="text-sm text-gray-600">
                      {client.sector}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <div className="text-sm text-gray-600">
                      {client.addresses.map((addr, idx) => (
                        <div key={idx}>{addr}</div>
                      ))}
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    <span className="text-sm font-medium text-gray-900">
                      {client.ai_score}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <span
                      className={`inline-flex px-2 py-1 text-xs font-medium rounded-md ${
                        client.status === "open"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {client.status.charAt(0).toUpperCase() +
                        client.status.slice(1)}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <span className="text-sm text-gray-600">
                      {client.posted_date}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <button className="text-gray-400 hover:text-gray-600">
                      <span className="text-xl font-bold">&#8942;</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="px-5 py-4 flex flex-col sm:flex-row items-center justify-between border-t border-gray-200">
          <div>
            <p className="text-sm font-semibold text-gray-900">
              Page <span>1</span> of <span>4</span>
            </p>
          </div>
          <div className="flex gap-3 items-center mt-3 sm:mt-0">
            <button className="text-sm border border-gray-300 text-gray-900 py-2 px-4 rounded-md cursor-pointer hover:bg-gray-50">
              Previous
            </button>
            <button className="text-sm text-gray-900 py-2 px-4 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-50">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsOverview;
